module.exports = __webpack_public_path__ + "img/rooms11.909de95d.png";